import { render, staticRenderFns } from "./GestionSiniestrosColaborador.vue?vue&type=template&id=78bf41c2&"
import script from "./GestionSiniestrosColaborador.vue?vue&type=script&lang=js&"
export * from "./GestionSiniestrosColaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports